import {writable} from 'svelte/store';

let kritikesObject = {
    tree: [],
    matches: [],

    selected_id: 0,
    last_selected_id: 0,
    marked_id: 0,

    search_term: '',
};

const {get, set, update, subscribe} = writable(kritikesObject);

const kritikes = {
    subscribe,
    update,
    set: o => {
        set(kritikesObject);
    },
}

export default kritikes;